/* VF: collapsible "Shop by vehicle" bar on /collections for phones
   (Asif, 2026-09-18).

   The Convermax year/make/model form on the collection list page starts as a
   single teal row and opens into the full form when tapped. The look and the
   collapse itself are CSS (vf_convermax.css), driven by two classes on <html>:
   vf-ymm-collapsible (set inline in snippets/vf_collection-ymm-toggle.liquid
   before Convermax renders, so nothing flashes) and vf-ymm-open.

   The state lives on <html> because Convermax owns and re-renders everything
   inside #cm-collection-list. The title is only decorated (role, tabindex,
   aria-expanded), never replaced, and that is re-applied on DOM changes.

   With a vehicle selected Convermax shows its compact "2021 Dodge Charger
   Parts / Change / Clear" template, which is never collapsed. "Change" opens
   the form, since asking to change is asking for the dropdowns. */
(function () {
  'use strict';
  var root = document.documentElement;
  var TITLE = '#cm-collection-list .cm_vehicle-widget_dropdowns .cm_vehicle-widget_title';
  var phone = window.matchMedia('(max-width: 768px)');

  function isOpen() { return root.classList.contains('vf-ymm-open'); }

  function decorate() {
    var t = document.querySelector(TITLE);
    if (!t) return;
    if (phone.matches) {
      if (t.getAttribute('role') !== 'button') t.setAttribute('role', 'button');
      if (t.getAttribute('tabindex') !== '0') t.setAttribute('tabindex', '0');
      var label = isOpen() ? 'Select your vehicle' : 'Shop by vehicle';
      if (t.getAttribute('aria-label') !== label) t.setAttribute('aria-label', label);
      var exp = String(isOpen());
      if (t.getAttribute('aria-expanded') !== exp) t.setAttribute('aria-expanded', exp);
    } else if (t.hasAttribute('role')) {
      ['role', 'tabindex', 'aria-label', 'aria-expanded'].forEach(function (a) { t.removeAttribute(a); });
    }
  }

  function setOpen(open) {
    root.classList.toggle('vf-ymm-open', open);
    decorate();
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('#cm-collection-list .cm_vehicle-widget__change')) { setOpen(true); return; }
    if (phone.matches && e.target.closest(TITLE)) setOpen(!isOpen());
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!phone.matches || !e.target || !e.target.closest || !e.target.closest(TITLE)) return;
    e.preventDefault();
    setOpen(!isOpen());
  });

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; decorate(); });
  }

  decorate();
  if (phone.addEventListener) phone.addEventListener('change', decorate);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
